import React from 'react';
import BlockContainer from './BlockContainer';
import Button from '../Button';

export default function ButtonBlock({
  link,
  bgColor,
  buttonColor,
  align,
  paddingTop,
  paddingBottom,
}) {
  if (!link?.link_text && !link?.link_url) return null;

  return (
    <BlockContainer
      bgColor={bgColor}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      align={align}
    >
      <Button color={buttonColor} solid lg to={link.link_url}>
        {link.link_text}
      </Button>
    </BlockContainer>
  );
}
